<template>
  <a-input-number
      v-show="info.status === 'edit'"
      :placeholder="'请填写' + info.title"
      :precision="widget.scale"
      v-model:value="value"
      style="width: 100%"
  />
  <div v-show="info.status === 'show'" class="view">
    <number-table :data="data" v-bind="$props"/>
  </div>
</template>

<script lang="ts" setup>
import {computed, defineProps} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import _ from "lodash";
import NumberTable from "./NumberTable.vue";
import {NumberFieldType} from "@/components/business/crud/interface/FieldType";

const props = defineProps<{
  propName: string;
  widget: NumberFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();

const value = computed({
  get() {
    return data.value[props.propName];
  },
  set(val?: number) {
    val = _.isFinite(val) ? val : undefined;
    if (val !== undefined && props.widget.type === 'string') {
      data.value[props.propName] = val.toString();
    } else {
      data.value[props.propName] = val;
    }
  }
})
</script>

<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
}
</style>
